import template from './therapyTemplate.html';
import controller from './therapy';

export default function ($stateProvider) {
    $stateProvider.state('therapy', {
        parent: 'ng-admin',
        url: '/therapies/:id',
        params: { },
        controller: [
            '$scope',
            '$stateParams',
            'Restangular',
            '$locale',
            '$location',
            '$window',
            controller
        ],
        template: template
    });
};



// WEBPACK FOOTER //
// ./js/therapy/therapyState.js